export default __webpack_public_path__ + "static/media/GamesCompetitiveAudit.1bf1b2e8.png";